(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

	/*
		This direcitive manages the list of available proporties for a given
		product. The directive contains a filter to deterine what to show
		and a single function to clone and attach to the product. This
		directive requires acess to the parent 'product' scope.
	*/

	ngModule.directive('productAvailableOptions', function () {
		return {
			scope: {
				product: '='
			},
			templateUrl: 'directives/productAvailableOptions/table.html',
			controller: function($scope) {

				/* List of possible Proporties. */
				$scope.available = [
					{ type: 'color',
					  attributes: [
						//   { name: 'red', price: 0, selected: false },
						//   { name: 'blue', price: 0, selected: false },
						//   { name: 'green', price: 0, selected: false },
						//   { name: 'yellow', price: 0, selected: false },
						//   { name: 'purple', price: 0, selected: false }
					  ]
					},
				    { type: 'inseam',
						attributes: [
							// { name: 'short', price: 0, selected: false },
							// { name: 'long', price: 0, selected: false },
							// { name: 'thin', price: 0, selected: false }
						]
					},
					{ type: 'fit',
					  attributes: [
						//   { name: 'small', price: '0', selected: false },
						//   { name: 'medium', price: '0', selected: false },
						//   { name: 'large', price: '0', selected: false },
						//   { name: 'extra large', price: 0, selected: false }
					  ]
					},
					{ type: 'sizes',
					  attributes: [
						//   { name: 'small', price: '0', selected: false },
						//   { name: 'medium', price: '0', selected: false },
						//   { name: 'large', price: '0', selected: false },
						//   { name: 'extra large', price: 0, selected: false }
					  ]
                    },
                    { type: 'options',
					  attributes: [
						//   { name: 'small', price: '0', selected: false },
						//   { name: 'medium', price: '0', selected: false },
						//   { name: 'large', price: '0', selected: false },
						//   { name: 'extra large', price: 0, selected: false }
					  ]
                    },

					// { type: 'images',
					// 	attributes: [
					// 		// { name: 'one', price: 0, selected: false },
					// 		// { name: 'two', price: 0, selected: false },
					// 		// { name: 'three', price: 0, selected: false },
					// 		// { name: 'four', price: 0, selected: false }
					// 	]
					// },
					// { type: 'customization',
					// 	attributes: [
					// 		// { name: 'funky', price: 0, selected: false },
					// 		// { name: 'special', price: 0, selected: false }
					// 	]
					// }
				];

				/* Filter to determine what to show in the list of available properties. */
				$scope.notSelected = function(input) {
					return !_.chain($scope.product.properties).pluck('type').contains(input.type).value();
				};

				/* Function to attach a given property to the product.properties array. */
				$scope.add = function(property) {
					if (!$scope.product.properties) $scope.product.properties = [];
					$scope.product.properties.push(angular.copy(property));
				};
			}
		};

	});

})();
